module.exports = __webpack_public_path__ + "static/aecon-logo-cd3bec6813412e06a373a9e1907b3e9b.png";